import React, { useEffect, useState } from 'react';
import PlaceholderIcon from '../../assets/placeholder.png';

type ProjectLogoProps = {
  src?: string;
  alt: string;
  height: string;
  width: string;
};

const ProjectLogo: React.FC<ProjectLogoProps> = ({ src, alt, height, width }) => {
  const [imgSrc, setImgSrc] = useState('');

  useEffect(() => {
    setImgSrc(src || PlaceholderIcon);
  }, [src]);
  return (
    <img
      src={imgSrc}
      alt={alt}
      onError={() => setImgSrc(PlaceholderIcon)}
      height={height}
      width={width}
    />
  );
};

export default ProjectLogo;
